var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "recent-daily-report-box" }, [
    _c("h3", { staticClass: "recent-head-title" }, [_vm._v("近期知识日报")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "recent-dailys" },
      _vm._l(_vm.dailyList, function(daily, index) {
        return _c(
          "section",
          {
            staticClass: "recent-daily-item",
            on: {
              click: function($event) {
                return _vm.setDailyRead(daily.ReleaseId, index)
              }
            }
          },
          [
            _c("div", { staticClass: "daily-head flexBox" }, [
              _c("h5", { staticClass: "flexBox" }, [
                _c("span", { domProps: { textContent: _vm._s(daily.Name) } }),
                _vm._v(" "),
                !daily.IsRead && index === 0 && _vm.$store.state.global.newDaily
                  ? _c("img", {
                      staticClass: "head-icon",
                      attrs: { src: "/static/images/icon/NEW.svg" }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "blank flexItem" }),
              _vm._v(" "),
              _c("span", { staticClass: "right-arrow" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "daily-body" }, [
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    daily.Description.replace(
                      /[\n↵]/g,
                      "<span class='mt-20'></span>"
                    )
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "analyse-info" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm._f("validCount")(daily.TotalViewCount)) + "人浏览"
                )
              ])
            ])
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "recent-bottom-tips" }, [
      _vm._v("\n        最多显示近两周的知识更新日报\n    ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-f21258b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-f21258b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/recentDailyReport.vue
// module id = null
// module chunks = 